import ApiClient from '../../../services/ApiClient2';

export function resetPassword(email) {
    return ApiClient.post('security/reset-password/send-message', {email});
}

export function validateCode(email, token) {
    return ApiClient.post('security/reset-password/check-token', {email, token});
}

export function setPassword(email, token, password) {
    return ApiClient.post('security/reset-password/set-new-password', {email, token, password});
}
